import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import variablesActions from '@state/variables/actions';

function useVariables() {

  const dispatch = useDispatch();
  const groups = useSelector(({ variables }) => variables.groups);
  const groupsLoading = useSelector(({ variables }) => variables.groupsLoading);

  const brands = useSelector(({ variables }) => variables.brands);
  const brandsLoading = useSelector(({ variables }) => variables.brandsLoading);

  const alarmsFields = useSelector(({ variables }) => variables.alarmsFields);
  const alarmsFieldsLoading = useSelector(({ variables }) => variables.alarmsFieldsLoading);

  const maintenanceTypes = useSelector(({ variables }) => variables.maintenanceTypes);
  const maintenanceTypesLoading = useSelector(({ variables }) => variables.maintenanceTypesLoading);

  const getGroups = useCallback(
    () => {

      dispatch(variablesActions.requestGroups());

    },
    // eslint-disable-next-line
    [groups]
  );

  const getBrands = useCallback(
    () => {

      dispatch(variablesActions.requestBrands());

    },
    // eslint-disable-next-line
    []
  );

  const getAlarmsFields = useCallback(() => {

    dispatch(variablesActions.requestAlarmsFields({ limit: 1000 }));
    // eslint-disable-next-line
  }, []);

  const getMaintenanceTypes = useCallback(() => {

    dispatch(variablesActions.requestMaintenanceTypes({ limit: 1000 }));
    // eslint-disable-next-line
  }, [maintenanceTypes]);

  return {
    groups,
    brands,
    getGroups,
    getBrands,
    groupsLoading,
    brandsLoading,
    getAlarmsFields,
    alarmsFields,
    alarmsFieldsLoading,
    maintenanceTypes,
    getMaintenanceTypes,
    maintenanceTypesLoading,
  };

}

export default useVariables;
